import { Helmet } from "react-helmet";
import { globalMetaData } from "../../config/constants/Strings";
import { MetaData } from "../../types";

interface IHead {
  canonical?: string;
  charset?: string;
  facebookDomainVerification?: string;
  favicon?: string;
  themeColor?: string;
  viewPort?: string;
  metaData: MetaData;
}

const Head: React.FC<IHead> = ({
  canonical,
  charset = globalMetaData.charset,
  facebookDomainVerification = globalMetaData.facebookDomainVerification,
  favicon = globalMetaData.favicon,
  themeColor = globalMetaData.themeColor,
  viewPort = globalMetaData.viewPort,
  metaData = {
    description: globalMetaData.description,
    title: globalMetaData.title,
    ogImage: globalMetaData.ogImage,
  },
}) => {
  return (
    <Helmet>
      <title>{metaData.title}</title>
      <meta name="description" content={metaData.description} />
      <meta charSet={charset} />
      <meta name="viewport" content={viewPort} />
      <meta name="theme-color" content={themeColor} />
      <meta property="og:title" content={metaData.title} />
      {metaData.ogImage && <meta property="og:image" content={metaData.ogImage} /> }
      <meta property="og:description" content={metaData.description} />
      <meta property="og:url" content={typeof window !== "undefined" ? window.location.href : ""} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Peakah" />
      <meta
        name="facebook-domain-verification"
        content={facebookDomainVerification}
      />
      <link rel="icon" href={`/${favicon}`} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default Head;
